import { Injectable } from '@angular/core';
import { Camera, MediaResult } from '@capacitor/camera';
import { Capacitor } from '@capacitor/core';
import { ModalController } from '@ionic/angular';
import { MultiCameraComponent } from '../lib/multi-camera/multi-camera.component';
import { ModalRole } from '../lib/models/modal-roles';

@Injectable({
  providedIn: 'root',
})
export class CameraService {
  constructor(private modalController: ModalController) {}

  public async getPhoto(): Promise<MediaResult> {
    return await Camera.takePhoto({
      includeMetadata: true,
      quality: 100,
      webUseInput: true,
    });
  }

  /** Keeps the camera open so the user can take several photos; returns JPEG blobs. */
  public async getPhotos(): Promise<Blob[]> {
    if (!Capacitor.isNativePlatform()) {
      const photo = await this.getPhoto();
      return [await fetch(photo.webPath).then((r) => r.blob())];
    }

    const modal = await this.modalController.create({
      component: MultiCameraComponent,
      cssClass: 'multi-camera-modal',
    });
    await modal.present();
    const { data, role } = await modal.onWillDismiss<Blob[]>();
    return role === ModalRole.Confirm && data ? data : [];
  }
}
